export const by = {
    ALL: "all",
    only: {
        VISITOR: "visitor",
        USER: "user",
        ADMIN: "admin"
    }
}


// WEBPACK FOOTER //
// ./src/common/routerAccess.js